module.exports = __webpack_public_path__ + "static/img/s3.b940a11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/img/slider/s3.jpg
// module id = ZFOi
// module chunks = 1